// color config
import {
  textTitleMyLearningJourney,
  btnFullScreenColor,
  btnFullScreenBackground,
} from "../../../../../../../../../config/constant/color/index";

const styles = {
  contentWrapper: {
    padding: "20px 40px",
  },
  contentWrapperMobile: {
    padding: "0",
    height: "100%",
  },
  headWrapper: {
    marginBottom: "15px",
  },
  headWrapperMobile: {
    // height: "8%",
    padding: "20px",
  },
  moduleCountFullname: {
    fontSize: "22px",
    color: textTitleMyLearningJourney,
    display: "flex",
    alignItems: "flex-start",
  },
  moduleCount: {
    fontWeight: "500",
    minWidth: "112px",
    display: "flex",
  },
  moduleFullname: {
    fontWeight:"400",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace:"nowrap"
  },
  fullscreenWrapper: {
    display: "flex",
    alignItems: "flex-end",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  buttonFullscreenStyle: {
    border: "1px solid " + btnFullScreenColor,
    borderRadius: "6px",
    backgroundColor: btnFullScreenBackground,
    color: btnFullScreenColor,
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
  },
  textFullscreen: {
    lineHeight: "normal",
  },
  iconFullscreen: {
    marginLeft: "4px",
    color: btnFullScreenColor,
    fontSize: "12px",
  },
};

export default styles;
